/* eslint-disable max-len */
import {
	Form, Input, Alert
} from "antd"
import React from "react"
import { localize } from "../../utils/localize"

export const ReportShareModalContext = React.createContext()

const emailValidation = value => {
	const re = /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	if (!value.length) { return Promise.reject(localize("Email is required")) }
	const emails = value.replace(/\s/g, "").split(",")
	let isValid = true
	emails.forEach(email => {
		if (!re.test(email)) { isValid = false }
	})
	return isValid ? Promise.resolve() : Promise.reject(localize("Invalid email"))
}

export const ShareForm = ({
	form, name, onChange, loading
}) => (
	<Form
		className={loading ? "custom-loader-spinner-type" : ""}
		labelCol={{ span: 5 }}
		form={form}
		name={name}
		onValuesChange={onChange}
	>
		<Alert message={localize("please-separate-multiple-recipients")} banner />
		<Form.Item
			name="to"
			label={localize("To")}
			required
			initialValue=""
			rules={[{ required: true, validator: (_, value) => emailValidation(value) }]}
		>
			<Input
				placeholder={localize("Please input your recipients addresses")}
				aria-label={localize("To")}
				aria-required="true"
			/>
		</Form.Item>
		<Form.Item
			name="from"
			label={localize("From")}
		>
			<Input
				disabled
				placeholder={process.env.REACT_APP_NOREPLY_EMAIL}
				aria-label={localize("From")}
			/>
		</Form.Item>
		<Form.Item
			name="subject"
			required
			rules={[{ required: true, message: localize("Please input email subject") }]}
			label={localize("Subject")}
		>
			<Input
				placeholder={localize("Please input email subject")}
				aria-label={localize("Subject")}
				aria-required="true"
			/>
		</Form.Item>
		<Form.Item
			name="replyTo"
			label={localize("ReplyTo")}
			initialValue=""
			rules={[{
				required: false,
				validator: (_, value) => {
					if (value.length === 0) {
						return Promise.resolve()
					}
					return emailValidation(value)
				}
			}]}
		>
<Input placeholder={localize("Please input an email for a reply")} aria-label={localize("ReplyTo")} />
		</Form.Item>
		<Form.Item
			name="comments"
			rules={[{ required: false, message: localize("Please input your comments") }]}
			label={localize("Comments")}
		>
<Input.TextArea rows={4} placeholder={localize("Please input your comments")} aria-label={localize("Comments")} />
		</Form.Item>
	</Form>
)
